
import { MAP_TILE_PROVIDERS } from "../utils/mapProviders";

export const useMapTiles = (darkMode) => {
    return darkMode
        ? MAP_TILE_PROVIDERS.cartoDarkMatter
        : MAP_TILE_PROVIDERS.cartoPositron;
};
